import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import Skeleton from "@saleor/components/Skeleton";
import useNotifier from "@saleor/hooks/useNotifier";
import { StoreOrderDetails_storeOrder } from "@saleor/storeOrders/types/StoreOrderDetails";
import React from "react";

import { maybe } from "../../../misc";

const useStyles = makeStyles(
  {
    content: {
      alignItems: "center"
    },
    copyBtn: {
      "&:hover": {
        background: "unset"
      },
      padding: "0px 0px 0px 5px"
    },
    icon: {
      height: "55px",
      marginRight: "17px",
      width: "40px"
    },
    lineOne: {
      textAlign: "center"
    },
    lineTwo: {
      fontWeight: "bold",
      textAlign: "center"
    },
    title: {
      fontSize: "1.3125rem"
    },
    // eslint-disable-next-line sort-keys
    root: {
      background: "#98dad0",
      borderColor: "#98dad0",
      display: "inline-block",
      width: "100%"
    }
  },
  { name: "StoreOrderSMACCard" }
);

interface StoreOrderSMACCardProps {
  storeOrder: StoreOrderDetails_storeOrder;
}

const StoreOrderSMACCard: React.FC<StoreOrderSMACCardProps> = props => {
  const { storeOrder } = props;
  const classes = useStyles(props);
  const notify = useNotifier();

  const copyToClipboard = text => {
    if (text && text.length > 0) {
      navigator.clipboard.writeText(text);
      notify({
        status: "success",
        text: "SMAC No. copied to clipboard"
      });
    }
  };

  return (
    <Card className={classes.root}>
      <CardContent className={classes.content}>
        <div className={classes.lineOne}>
          {" "}
          <span>Please input the Customer's SMAC No. on your POS</span>
        </div>
        <div className={classes.lineTwo}>
          {" "}
          <span>
            {maybe(() => storeOrder?.smac) === undefined ? (
              <Skeleton />
            ) : storeOrder?.smac === null ? (
              <span className={classes.title}>Not set</span>
            ) : (
              <div className={classes.title} id="smacno">
                <span id="smacnoTxt">{storeOrder?.smac}</span>
                <IconButton
                  id="smacnoCardCopyBtn"
                  aria-label="copy"
                  className={classes.copyBtn}
                  onClick={() => copyToClipboard(storeOrder?.smac)}
                >
                  <FileCopyOutlinedIcon fontSize="small" />
                </IconButton>
              </div>
            )}
          </span>
        </div>
      </CardContent>
    </Card>
  );
};

export default StoreOrderSMACCard;
